import React, { Component } from "react";
import SwaggerAPI from "../api/SwaggerAPI";
import UserAPI from "../api/UserAPI";
import queryString from "query-string";

import SidePanel from "./swagger-view/SidePanel";
import ContentView from "./swagger-view/ContentView";

import "react-confirm-alert/src/react-confirm-alert.css";
import "../css/SwaggerView.css";
import "swagger-ui/dist/swagger-ui.css";

class SwaggerView extends Component {
  state = {
    swaggers: [],
    groups: [],
    groupId: "",
    swaggerId: "",
  };

  componentDidMount() {
    const { groupId, swaggerId } = queryString.parse(this.props.location.search);
    if (groupId && swaggerId) {
      this.setState({ groupId, swaggerId });
    }

    this.getSwaggers();
  }

  getSwaggers = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    UserAPI.getUserGroups(user.id).then(groups => {
      this.setState({ groups });

      const swaggersPromises = groups.map(group => {
        return SwaggerAPI.getSwaggers(group.id);
      });

      Promise.all(swaggersPromises).then(swaggerGroups => {
        this.setState({
          swaggers: swaggerGroups
        });
      });
    });
  }

  createSwagger = ({ groupId, name, content }) => {
    const swagger = {
      name: name,
      content: content
    };

    SwaggerAPI.createSwagger(groupId, swagger)
      .then(swagger => {
        this.getSwaggers();
        this.hideCreateModal();
      })
      .catch(err => {});
  }

  loadSwagger = (groupId, swaggerId) => {
    this.props.history.push(`/swaggers?groupId=${groupId}&swaggerId=${swaggerId}`)
    this.setState({ groupId, swaggerId });
  }

  goToCompare = (groupId, swaggerId) => {
    this.props.history.push(`/swaggers-diff/${groupId}/${swaggerId}`);
  }

  goToEditor = (groupId, swaggerId) => {
    this.props.history.push(`/swaggers-edit?groupId=${groupId}&swaggerId=${swaggerId}`);
  }

  render() {
    return (
      <div className="swaggers-div">
        <SidePanel
          loadSwagger={this.loadSwagger}
          groups={this.state.groups}
          swaggers={this.state.swaggers}
          createSwagger={this.createSwagger} />
        <ContentView
          onCompareSwagger={this.goToCompare}
          onEditSwagger={this.goToEditor}
          swaggerId={this.state.swaggerId}
          groupId={this.state.groupId}
          reloadSwaggers={this.getSwaggers} />
      </div>
    );
  }
}

export default SwaggerView;



// WEBPACK FOOTER //
// ./src/components/SwaggerView.js